'use client';

export { default } from './MenuList';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/MenuList/index.js
// module id = 489
// module chunks = 22